import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MessageCircleIcon, XIcon, ZoomInIcon } from 'lucide-react';
import { whatsapps } from '../data/whatsapps';
import { Reveal } from './Reveal';
export function WhatsappProof() {
  const [zoomed, setZoomed] = useState<number | null>(null);
  const active = zoomed === null ? null : whatsapps[zoomed];
  return <section className="border-t border-paper-line bg-paper px-5 py-20 sm:py-28 lg:px-8" aria-labelledby="whatsapps" data-id="element-202" data-mp="2a4foe5uo2o33">
      <div className="mx-auto max-w-6xl" data-id="element-203" data-mp="25d7df5douunt">
        <Reveal data-id="element-204" data-mp="25c600u979w2x">
          <p className="flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-205" data-mp="20emmjwkbtnc1">
            <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-206" data-mp="1vgktcit6s7mu" />
            Mensajes reales
          </p>
          <h2 id="whatsapps" className="display mt-4 max-w-3xl text-4xl text-ink sm:text-5xl lg:text-6xl" data-id="element-207" data-mp="1rd6cjpxfbn8c">
            Lo que me escriben los profes después de usarlo
          </h2>
          <p className="mt-6 max-w-readable text-lg text-ink-soft" data-id="element-208" data-mp="cyartfvdynl3">
            Capturas tal cual llegan al WhatsApp. Tocá cualquiera para leer la charla
            completa.
          </p>
        </Reveal>

        <ul className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-209" data-mp="410ezq2x6qe2">
          {whatsapps.map((chat, i) => <Reveal key={chat.name} delay={i * 0.05} className="h-full" data-id="element-210" data-mp="7yo94qwsgf4w" data-mpi={i}>
              <li className="flex h-full flex-col" data-id="element-211" data-mp="vqv1zg3b23zk">
                <button type="button" onClick={() => setZoomed(i)} className="group relative block overflow-hidden rounded-xl border border-paper-line bg-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grass" aria-label={`Ver la conversación completa con ${chat.name}`} data-id="element-212" data-mp="10p6gi44jp2o4">
                  <img src={chat.image} alt={chat.alt} loading="lazy" className="h-[24rem] w-full object-cover object-top transition-transform duration-200 ease-out group-hover:scale-[1.02]" data-id="element-213" data-mp="3cf8zeavagav5" />
                  <span className="pointer-events-none absolute inset-x-0 bottom-0 flex h-24 items-end justify-center bg-gradient-to-t from-ink to-transparent pb-3 text-xs font-bold uppercase tracking-wide text-white" data-id="element-214" data-mp="188fkfhua895s">
                    <span className="flex items-center gap-1.5" data-id="element-215" data-mp="z9asiud87e2l">
                      <ZoomInIcon className="h-4 w-4" aria-hidden="true" data-id="element-216" data-mp="u9fwkcelfyao" />
                      Ver charla completa
                    </span>
                  </span>
                </button>

                <div className="mt-5 flex flex-1 flex-col" data-id="element-217" data-mp="l8hva1vji4vs">
                  <p className="text-sm font-bold uppercase tracking-wide text-ink" data-id="element-218" data-mp="lab0rduf2j27">
                    {chat.name}
                    <span className="ml-2 font-medium normal-case text-ink-dim" data-id="element-219" data-mp="2jm05fwt76j8y">
                      {chat.role}
                    </span>
                  </p>
                  <p className="mt-2 text-[15px] leading-relaxed text-ink-soft" data-id="element-220" data-mp="1dym177117t4">
                    {chat.highlight}
                  </p>
                </div>
              </li>
            </Reveal>)}
        </ul>
      </div>

      <AnimatePresence data-id="element-221" data-mp="b6ntzs3dc3jp">
        {active && <motion.div className="fixed inset-0 z-[60] flex items-center justify-center bg-ink/85 p-4 sm:p-8" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} onClick={() => setZoomed(null)} role="dialog" aria-modal="true" aria-label={`Conversación completa con ${active.name}`} data-id="element-222" data-mp="f6eljy0pynpa">
            <motion.img src={active.image} alt={active.alt} className="max-h-full w-auto rounded-xl shadow-2xl" initial={{
          opacity: 0,
          scale: 0.96
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.96
        }} transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} onClick={event => event.stopPropagation()} data-id="element-223" data-mp="12vzbx1z7cn8l" />
            <button type="button" onClick={() => setZoomed(null)} aria-label="Cerrar" className="absolute right-4 top-4 flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white transition-colors duration-150 ease-out hover:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white" data-id="element-224" data-mp="1ffwcphzun4se">
              <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-225" data-mp="1u391dfkydqn0" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </section>;
}